import React, { type JSX } from 'react';

export interface ToggleInputProps {
  label: JSX.Element | string;
  id?: string;
  isOn: boolean;
  backgroundColor?: string;
  onToggle: () => void;
  dataTestId?: string;
  UNSAFE_className?: string;
  isDisabled?: boolean;
}

const ToggleInput: React.FC<ToggleInputProps> = ({
  label,
  id,
  isOn,
  backgroundColor,
  onToggle,
  isDisabled,
  dataTestId,
  UNSAFE_className = '',
}) => {
  return (
    <div
      className={`tw-relative tw-flex ${
        backgroundColor ? `tw-rounded-lg tw-p-3` : ''
      } ${UNSAFE_className}`}
      style={{ backgroundColor }}
    >
      <button
        id={id}
        type="button"
        aria-labelledby={`${id}-label`}
        disabled={isDisabled}
        className={`
          tw-lf-button-clear
          tw-relative
          tw-h-6
          tw-w-12 tw-shrink-0
          tw-rounded-full
          tw-bg-black-600
          tw-outline-none
          tw-transition-all tw-duration-200 tw-ease-in
          after:tw-absolute
          after:tw-left-[3px]
          after:tw-top-[3px]
          after:tw-block after:tw-size-[18px] after:tw-rounded-full
          after:tw-bg-white after:tw-shadow-[0_0_0_7px_rgba(0,0,0,0)] after:tw-transition-all
          after:tw-duration-200
          after:tw-ease-in
          after:tw-content-['']
          after:hover:tw-shadow-black-600/40 after:focus:tw-shadow-black-600/40
          ${
            isOn
              ? 'tw-bg-yellow-600 after:tw-left-[calc(100%-18px-3px)] after:hover:tw-shadow-yellow-600/40 after:focus:tw-shadow-yellow-600/40'
              : ''
          }
        `}
        onClick={onToggle}
        role="switch"
        aria-checked={isOn ? 'true' : 'false'}
        data-testid={dataTestId}
      />
      <p id={`${id}-label`} className="tw-lf-form-input-label tw-m-0 tw-pl-2">
        {label}
      </p>
    </div>
  );
};

export default ToggleInput;
